import React, { FC } from 'react'
import { EldIntegrationList } from '../eld-integration/EldIntegrationList'
import { UserSettingsCard } from './UserSettingsCard'

/**
 * User settings page for all Integrations in Fleet Planner
 */
export const IntegrationsCard: FC = () => {
  return (
    <UserSettingsCard
      title='ELD Integrations'
      subtitle='When you bring your ELD-connected trucks into Transfix, you’ll be able see your truck’s current location and get live tracking updates for loads.'>
      <div className='mt4 pb4' />
      <EldIntegrationList />
    </UserSettingsCard>
  )
}
